import { VExpansionPanel } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanelContent } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanelHeader } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanels } from 'vuetify/lib/components/VExpansionPanel';
import Ripple from 'vuetify/lib/directives/ripple';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    VExpansionPanels,
    {
      staticClass: "other-countries-of-doctor-work justify-start",
      class: {
        "other-countries-of-doctor-work--desktop": !_setup.isMobile,
        "other-countries-of-doctor-work--mobile": _setup.isMobile,
      },
      attrs: { accordion: "", flat: "", multiple: "", tile: "" },
      model: {
        value: _setup.expandedPanels,
        callback: function ($$v) {
          _setup.expandedPanels = $$v
        },
        expression: "expandedPanels",
      },
    },
    [
      _c(
        VExpansionPanel,
        {
          staticClass: "other-countries-of-doctor-work__expansion-panel",
          class: {
            "other-countries-of-doctor-work__expansion-panel--desktop":
              !_setup.isMobile,
            "other-countries-of-doctor-work__expansion-panel--mobile":
              _setup.isMobile,
          },
        },
        [
          _c(
            VExpansionPanelHeader,
            {
              staticClass: "other-countries-of-doctor-work__panel-header",
              attrs: { "expand-icon": "ui-icon-arrow-down" },
            },
            [
              _c("div", { staticClass: "d-flex align-center" }, [
                _c("span", {
                  staticClass:
                    "ui-icon-globe icon-secondary--text ui-icon-fz-medium mr-4",
                }),
                _vm._v(" "),
                _c("div", { staticClass: "text-body-1 text--text mr-auto" }, [
                  _vm._v(
                    "\n          " +
                      _vm._s(
                        _setup.t("Принимает в других странах", _setup.options)
                      ) +
                      "\n        "
                  ),
                ]),
              ]),
            ]
          ),
          _vm._v(" "),
          _c(
            VExpansionPanelContent,
            _vm._l(
              _setup.otherCountriesOfWork,
              function ({ name, link }, index) {
                return _c(
                  "a",
                  {
                    directives: [{ def: Ripple, name: "ripple", rawName: "v-ripple" }],
                    key: index,
                    staticClass:
                      "d-flex align-center cursor-pointer text-decoration-none py-3 pl-9",
                    attrs: { href: link },
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "text-body-1 text--text mr-auto" },
                      [_vm._v("\n          " + _vm._s(name) + "\n        ")]
                    ),
                    _vm._v(" "),
                    _c("span", {
                      staticClass:
                        "ui-icon-arrow-right icon-secondary--text ml-4",
                    }),
                  ]
                )
              }
            ),
            0
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }